export const EXCEL_FILES_QUERY_KEY = ["excel-files"] as const;

